import { lazy } from 'react'

export default {
  List: lazy(() => import('./List')),
  Detail: lazy(() => import('./Detail')),
}